import { api } from "./api";

/**
 * Release runbook
 *
 * The two read paths are shaped for EnhancedTable: it sends limit, offset,
 * ordering and search, and reads {count, results} back.
 *
 * Ticking and archiving reuse the endpoints the Django page already posts to,
 * so there is one write path for both front ends.
 */
export function getRunbooks(params) {
  return api.get(`/release-runbook/runbooks`, { params });
}

export function getRunbook(code) {
  return api.get(`/release-runbook/runbooks/${code}`);
}

export function getRunbookItems(code, params) {
  return api.get(`/release-runbook/runbooks/${code}/items`, { params });
}

export function recordResult({ item, state, note }) {
  return api.post(`/release-runbook/results`, { item, state, note });
}

export function archiveRunbook(code) {
  return api.post(`/release-runbook/${code}/export`);
}
